import { useSelector } from "react-redux";
import Maybe from "components/__new/common/Maybe";
import PageContent from "components/__new/common/PageContent";
import Table from "components/__new/common/Table";
import CurrencyFormat from "utils/currencyFormat";


export const TaxAndDeductionSummary = (props) => {
    const { payroll } = props;
    const { payrollLoading, payrollTransactionsGenerateLoading } = useSelector((s) => s.entities.runPayroll);
    

    /*
    const { id, payroll } = props;
    const dispatch = useDispatch();
    const { payrollTaxAndDeductionSummaryLoading, payrollTaxAndDeductionSummary } = useSelector((s) => s.entities.runPayroll);


    const getPayrollTaxAndDeductionSummary = () => {
        dispatch(payrollAction.getPayrollTaxAndDeductionSummary(id));
    }


    useEffect(() => {
        if (id){
            if (
                payrollTaxAndDeductionSummary?.taxDetails === undefined ||
                payrollTaxAndDeductionSummary?.preTaxDeductions === undefined ||
                payrollTaxAndDeductionSummary?.postTaxDeductions === undefined
            ){
                getPayrollTaxAndDeductionSummary();
            }
        }
        // eslint-disable-next-line
    }, [id]);
    */

    
    return (
        <>
            <PageContent
                loading={payrollLoading || payrollTransactionsGenerateLoading}
                data={payroll?.transaction_metrics}
                loadingText="Loading tax and deduction summary"
                emptyText="Tax and deduction summary not found"
                errorText="Unable to load tax and deduction summary"
            />


            <Maybe condition={payrollLoading === false && payrollTransactionsGenerateLoading === false && payroll?.transaction_metrics !== undefined}>
                <div className="table-style-2 table-tax-deduction-summary">

                    <Maybe condition={payroll?.type === "GROSS"}>
                        <div className="p-4 pt-0 font-medium">
                            Tax Details
                        </div>
                        
                        <Table>
                            <Table.Head>
                                <th>TAX NAME</th>
                                <th>PAID BY BUSINESS</th>
                                <th>PAID BY EMPLOYEE </th>
                            </Table.Head>
                            <Table.Body>

                                {(()=>{
                                    let totalEmployer = 0;
                                    let totalEmployee = 0;

                                    return (
                                        <>

                                            {payroll?.transaction_metrics?.taxes?.map((tax, index) => {
                                                totalEmployer += tax?.employer_amount || 0;
                                                totalEmployee += tax?.employee_amount || 0;
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            {tax?.name}
                                                        </td>
                                                        <td>
                                                            {CurrencyFormat(tax?.employer_amount)}
                                                        </td>
                                                        <td>
                                                            {CurrencyFormat(tax?.employee_amount)}
                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                            {(!payroll?.transaction_metrics?.taxes || payroll?.transaction_metrics?.taxes?.length === 0) &&
                                                <tr>
                                                    <td>
                                                        -
                                                    </td>
                                                    <td>
                                                        -
                                                    </td>
                                                    <td>
                                                        -
                                                    </td>
                                                </tr>
                                            }

                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Total
                                                    </div>
                                                </td>
                                                <td>
                                                    {CurrencyFormat(totalEmployer)}
                                                </td>
                                                <td>
                                                    {CurrencyFormat(totalEmployee)}
                                                </td>
                                            </tr>
                                            
                                        </>
                                    )
                                })()}
                                
                            </Table.Body>
                        </Table>
                        
                        <div className="p-4 font-medium border-t border-gray-200">
                            Pre-Tax Deductions
                        </div>

                        <Table>
                            <Table.Head>
                                <th>DEDUCTION NAME</th>
                                <th>PAID BY BUSINESS</th>
                                <th>PAID BY EMPLOYEE </th>
                            </Table.Head>
                            <Table.Body>

                                {(()=>{
                                    let totalEmployer = 0;
                                    let totalEmployee = 0;

                                    return (
                                        <>

                                            {payroll?.transaction_metrics?.pre_tax_deductions?.map((deduction, index) => {
                                                totalEmployer += deduction?.employer_amount || 0;
                                                totalEmployee += deduction?.employee_amount || 0;
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            {deduction?.name}
                                                        </td>
                                                        <td>
                                                            {CurrencyFormat(deduction?.employer_amount)}
                                                        </td>
                                                        <td>
                                                            {CurrencyFormat(deduction?.employee_amount)}
                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                            {(!payroll?.transaction_metrics?.pre_tax_deductions || payroll?.transaction_metrics?.pre_tax_deductions?.length === 0) &&
                                                <tr>
                                                    <td>
                                                        -
                                                    </td>
                                                    <td>
                                                        -
                                                    </td>
                                                    <td>
                                                        -
                                                    </td>
                                                </tr>
                                            }

                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Total
                                                    </div>
                                                </td>
                                                <td>
                                                    {CurrencyFormat(totalEmployer)}
                                                </td>
                                                <td>
                                                    {CurrencyFormat(totalEmployee)}
                                                </td>
                                            </tr>
                                            
                                        </>
                                    )
                                })()}

                            </Table.Body>
                        </Table>
                    </Maybe>

                    <Maybe condition={payroll?.type === "GROSS"}>
                        <div className="p-4 font-medium border-t border-gray-200">
                            Post-Tax Deductions
                        </div>
                    </Maybe>

                    <Maybe condition={payroll?.type === "NET"}>
                        <div className="p-4 pt-0 font-medium">
                            Post-Tax Deductions
                        </div>
                    </Maybe>

                    <Table>
                        <Table.Head>
                            <th>DEDUCTION NAME</th>
                            <th>PAID BY BUSINESS</th>
                            <th>PAID BY EMPLOYEE </th>
                        </Table.Head>
                        <Table.Body>

                            {(()=>{
                                let totalEmployer = 0;
                                let totalEmployee = 0;

                                return (
                                    <>

                                        {payroll?.transaction_metrics?.post_tax_deductions?.map((deduction, index) => {
                                            totalEmployer += deduction?.employer_amount || 0;
                                            totalEmployee += deduction?.employee_amount || 0;
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {deduction?.name}
                                                    </td>
                                                    <td>
                                                        {CurrencyFormat(deduction?.employer_amount)}
                                                    </td>
                                                    <td>
                                                        {CurrencyFormat(deduction?.employee_amount)}
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                        {(!payroll?.transaction_metrics?.post_tax_deductions || payroll?.transaction_metrics?.post_tax_deductions?.length === 0) &&
                                            <tr>
                                                <td>
                                                    -
                                                </td>
                                                <td>
                                                    -
                                                </td>
                                                <td>
                                                    -
                                                </td>
                                            </tr>
                                        }

                                        <tr>
                                            <td>
                                                <div className="font-medium">
                                                    Total
                                                </div>
                                            </td>
                                            <td>
                                                {CurrencyFormat(totalEmployer)}
                                            </td>
                                            <td>
                                                {CurrencyFormat(totalEmployee)}
                                            </td>
                                        </tr>
                                        
                                    </>
                                )
                            })()}

                        </Table.Body>
                    </Table>

                </div>
            </Maybe>
        </>
    )
}